import React from "react";
import { CheckCircle2, ShieldCheck } from "lucide-react";
import { qualification } from "../../content/siteContent";
import { SectionHeading } from "./primitives";
import { Reveal } from "../motion/Reveal";

export const Qualification = () => (
  <section
    id="qualification"
    data-testid="qualification-section"
    className="bg-navy-2 py-24 lg:py-32 relative overflow-hidden"
  >
    <div className="absolute inset-0 blueprint opacity-60" />
    <div className="container-page relative grid lg:grid-cols-12 gap-12 lg:gap-16">
      <div className="lg:col-span-6">
        <SectionHeading eyebrow={qualification.eyebrow} dark>
          {qualification.heading}
        </SectionHeading>
        <Reveal delay={0.1}>
          <p className="mt-6 text-white/75 text-base lg:text-lg leading-relaxed max-w-xl">
            {qualification.positioning}
          </p>
        </Reveal>
        <Reveal delay={0.15}>
          <div className="mt-8 inline-flex items-center gap-3 border border-gold/40 bg-gold/10 px-5 py-3 rounded-sm">
            <ShieldCheck className="h-5 w-5 text-gold" />
            <span className="text-white font-display font-semibold text-sm">{qualification.callout}</span>
          </div>
        </Reveal>
      </div>

      <div className="lg:col-span-6">
        <Reveal delay={0.1} className="border border-hair-dark bg-navy/50 backdrop-blur-sm rounded-sm p-8 lg:p-10">
          <p className="eyebrow text-teal mb-6">Qualification detail</p>
          <ul className="space-y-4">
            {qualification.facts.map((f) => (
              <li key={f} className="flex items-start gap-3">
                <CheckCircle2 className="h-4 w-4 text-teal mt-1 shrink-0" />
                <span className="text-white/85 text-sm lg:text-[15px] leading-relaxed">{f}</span>
              </li>
            ))}
          </ul>
        </Reveal>
      </div>
    </div>

    <div className="container-page relative mt-14" data-testid="qualification-units">
      <div className="border border-hair-dark bg-navy/40 backdrop-blur-sm rounded-sm p-8 lg:p-10">
        <div className="flex flex-wrap items-end justify-between gap-4">
          <p className="font-display font-bold text-white text-lg tracking-tight">{qualification.unitsHeading}</p>
          <div className="flex items-center gap-4 text-xs">
            <span className="inline-flex items-center gap-2 text-white/70"><span className="h-2.5 w-2.5 rounded-sm bg-teal" /> Core</span>
            <span className="inline-flex items-center gap-2 text-white/70"><span className="h-2.5 w-2.5 rounded-sm bg-gold" /> Elective</span>
          </div>
        </div>
        <div className="mt-8 grid sm:grid-cols-2 lg:grid-cols-3 gap-x-8 gap-y-5">
          {qualification.units.map((u) => (
            <div key={u.code} className="flex items-start gap-3 border-b border-hair-dark/60 pb-4">
              <span className={`mt-1 h-2.5 w-2.5 rounded-sm shrink-0 ${u.type === "Core" ? "bg-teal" : "bg-gold"}`} />
              <div>
                <p className="font-display font-semibold text-white text-sm tracking-tight">{u.code}</p>
                <p className="mt-0.5 text-white/70 text-sm leading-snug">{u.title}</p>
              </div>
            </div>
          ))}
        </div>
        <p className="mt-8 text-white/50 text-xs leading-relaxed max-w-3xl">{qualification.unitsNote}</p>
      </div>
    </div>

    <div className="container-page relative mt-12">
      <p className="text-white/40 text-xs leading-relaxed max-w-4xl">{qualification.disclaimer}</p>
    </div>
  </section>
);
